module.exports = __webpack_public_path__ + "fa-solid-900.4d496c9d7dd88333d8c3.svg";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/assets/fonts/webfonts/fa-solid-900.svg
// module id = ../../../../../src/assets/fonts/webfonts/fa-solid-900.svg
// module chunks = styles